import React, { useContext, useState } from "react";
import { CustomDefaultTheme } from "../themes/CustomDefault";
import { Container, ThemeProvider } from "@material-ui/core";
import NavigationBar from "../components/Navigation/NavigationBar";
import Footer from "../components/Navigation/Footer";


interface IThemeContextData {
    themeName: "Default";
}

export const useThemeRequestContext = () => {
    return useContext(ThemeRequestContext);
};

export const ThemeRequestContext = React.createContext({} as IThemeContextData);

export function AppThemeRequestProvider(props: any) {

    const [themeName] = useState<"Default">("Default");

    return (
        <ThemeRequestContext.Provider value={{ themeName }}>
            <ThemeProvider theme={CustomDefaultTheme}>                
                <NavigationBar />
                <Container maxWidth="lg">
                    {props.children}
                    <Footer />
                </Container>
            </ThemeProvider>
        </ThemeRequestContext.Provider>
    );

};